module.exports = __webpack_public_path__ + "img/asset-group-survey-result.f38da44d.png";